import React from "react";

const TimelineSkeleton = () => (
  <div className="mat-skeleton" data-testid="mat-skeleton">
    <div className="mat-skeleton-cards row g-3">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="col-6 col-md-3">
          <div className="mat-skeleton-block mat-skeleton-card" />
        </div>
      ))}
    </div>
    <div className="mat-skeleton-block mat-skeleton-chart" />
    <div className="mat-skeleton-block mat-skeleton-chart mat-skeleton-chart-sm" />
  </div>
);

export default TimelineSkeleton;
